import React, { useEffect, useState, lazy } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import App from './App';
import useApolloClient from '../hooks/useApolloClient';
// import usePushPros from '../hooks/usePushPros';
import { ApolloProvider } from '@apollo/client';
import { StyleRoot } from 'radium';
import '../assets/fonts.css';
import '../assets/overrides.css';

// fontawesome
import initFontAwesome from '../utils/initFontAwesome';
initFontAwesome();

const history = createBrowserHistory();

const AmericanTheme = lazy(() => import('../assets/themes/american'));
const GoldTheme = lazy(() => import('../assets/themes/gold_seal'));
const DreamTheme = lazy(() => import('../assets/themes/dream_home'));
const SuperTheme = lazy(() => import('../assets/themes/supermarket'));

const ThemeSelector = ({ campaign, children }) => (
	<>
	<React.Suspense fallback={<></>}>
		{(campaign === 'american') && <AmericanTheme />}
		{(campaign === 'gold') && <GoldTheme />}
		{(campaign === 'dream') && <DreamTheme />}
		{(campaign === 'super') && <SuperTheme />}
	</React.Suspense>
	{children}
	</>
);

const campaignSelector = (co) => {
	switch(co) {
		case 'co1':
			document.title = 'GreatAmerican';
			return 'american';
		case 'co2':
			document.title = 'GoldSeal';
			return 'gold';
		case 'co3':
			document.title = 'DreamHome';
			return 'dream';
		case 'co4':
			document.title = 'SuperMarket';
			return 'super';
		default:
			console.log('no subdomain specified.')
			return 'gold';
	}
};

const Global = () => {
	const [ campaign, setCampaign ] = useState(null);
	// usePushPros('https://pushpros.tech/GetPushScript?key=2Xa3N8H4tIMDq5DaLOjgimHq4HG8UhWO&domain=');
	// const apolloUri = 'https://services.bluekeel-api.com/graphql';
	// const apolloUri = 'https://cbvb02ezl4.execute-api.us-east-1.amazonaws.com/prod/graphql';
	// const apolloUri = 'https://d234ckldiolt4m.cloudfront.net/services/graphql';
	const apolloUri = 'https://uqwaw9keg3.execute-api.us-east-1.amazonaws.com/services/graphql';
	// const apolloUri = 'https://cypmxq177b.execute-api.us-east-1.amazonaws.com/test/graphql';
	// const apolloUri = 'http://localhost:4000/dev/graphql';

	useEffect(() => {
		if(!campaign) {
			let app_key;
			app_key = window.location.host.split('.')[0];
			if(app_key === 'coreg-staging') {
				app_key = window.location.pathname.slice(1,4);
			};
			const campaignValue = campaignSelector(app_key);
			setCampaign(campaignValue);
		};

	},[campaign]);

	const client = useApolloClient(apolloUri);

	if(!campaign) {
		return null;
	};
	// const WrappedApp = Radium(App);
	return (
		<ApolloProvider client={ client }>
            <Router history={ history }>
				<StyleRoot>
					<ThemeSelector campaign={campaign}>
						<App campaign={campaign}/>
					</ThemeSelector>
				</StyleRoot>
            </Router>
		</ApolloProvider>
	);
};


export default Global;